import axios from 'axios';
import * as endpoints from '../shared/constants/api-constants';

class RatingService {
  static rating(id) {
    return axios
      .get(endpoints.rating + 'answers/product/' + id + '/question/category?countryId=' + process.env.COUNTRY_CODE)
      .then(resp => resp.data);
  }

  static saveRating(payload) {
    payload.countryId = process.env.COUNTRY_CODE
    return axios
      .post(endpoints.rating + 'answers/save', JSON.stringify(payload), {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(resp => resp.data);
  }

  static getComment(idProduct, limit, offset) {
    return axios
      .get(
        endpoints.rating +
          'answers/product/' +
          idProduct +
          '/comments/?limit=' +
          limit +
          '&offset=' +
          offset +
          '&countryId=' +
          process.env.COUNTRY_CODE
      )
      .then(resp => resp.data);
  }

  // Obtener calificaciones detalladas de un producto
  static getQualification(idProduct) {
    return axios
      .get(
        endpoints.rating +
          'answers/product/' +
          idProduct +
          '/grouped/qualification'+
          '?countryId=' +
          process.env.COUNTRY_CODE
      )
      .then(resp => resp.data);
  }

  // Obtener calificaciones de todos los productos
  static getProductAvg(idProduct = null) {
    const product = idProduct != null ? '&productId=' + idProduct : '';
    // console.log(product);

    return axios
      .get(endpoints.rating + 'products/average?countryId=' + process.env.COUNTRY_CODE + product)
      .then(resp => resp.data);
  }
}

export default RatingService;
